// @ts-nocheck
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import StoreProductDetailsNotEnoughStockMessage from "@store/Library/Components/Foundation/StoreProduct/StoreProductDetailsNotEnoughStockMessage";
import React from "react";

type Props = WidgetProps & HasProduct;

const ProductDetailsNotEnoughStockMessage = ({ product }: Props) => {
    if (!product) {
        return null;
    }

    return <StoreProductDetailsNotEnoughStockMessage />;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsNotEnoughStockMessage),
    definition: {
        displayName: "Not Enough Stock Message",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
